import { render, staticRenderFns } from "./NuevoEnfermero.vue?vue&type=template&id=7e846443"
import script from "./NuevoEnfermero.vue?vue&type=script&lang=js"
export * from "./NuevoEnfermero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports